<div class="flex flex-col items-center">
  <img src="/frontend-assets/images/no-image.webp" class="w-52" />
  <atom-btn-input-file [controlName]="controlName" class="mt-11" (eventChooseImage)="eventChooseImage.emit($event)"></atom-btn-input-file>
</div>